export default "__VITE_ASSET__15e14b32__"